module.exports = __webpack_public_path__ + "img/BINDI 4 PURPLE.3d236ea.svg";